export const TestHooks = {
	AddTextButton: 'add-text-button',
	ClientSearchInput: 'client-search-input',
} as const;
